module.exports = __webpack_public_path__ + "static/img/2.8f165e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/eng/2.png
// module id = LnpL
// module chunks = 0